import { RefObject } from 'react';
import { handleHexCode } from './handleHexCode';

export const createColourPng = (
  ref: RefObject<HTMLDivElement | null>,
  colour: string
): string => {
  if (typeof window !== 'undefined') {
    const imageWidth = ref.current?.offsetWidth || 100;
    const imageHeight = ref.current?.offsetHeight || 100;

    const canvas = document.createElement('canvas');
    canvas.width = imageWidth;
    canvas.height = imageHeight;
    const ctx = canvas.getContext('2d');

    if (ctx) {
      ctx.fillStyle = handleHexCode(colour);
      ctx.fillRect(0, 0, imageWidth, imageHeight);
    }

    return canvas.toDataURL();
  }

  return '';
};
